"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Days(_a) {
    var data = _a.data, setDate = _a.setDate;
    if (!data.days) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-events-days' }, data.days.map(function (day, index) {
        return react_1.default.createElement("div", { key: index, className: storybook_1.Helpers.classNames('storybook-events-days-day', !day.events ? 'opacity-50' : ''), onClick: function () { return setDate(day.date); } },
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2' }, day.day),
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'uppercase font-bold' }, day.label),
            day.active && react_1.default.createElement("span", { className: 'storybook-events-days-today-active' }));
    }));
}
exports.default = Days;
